import { AppService } from './../../../core/app.service';
import { ActivtieResponse } from './../../../data/http/responses/activite.response';
import { Component, CUSTOM_ELEMENTS_SCHEMA, OnInit } from "@angular/core";
import { ActivatedRoute, Router, RouterOutlet } from "@angular/router";
import { routeAlias } from "../../../../routesalias";
import { ReportService } from "../../../services/report.service";
import { createActivite, IActivite } from "../model/IActivite";
import { ActiviteForReportService } from "../../../services/activiteForReportService";
import { TypeInterventionService } from "../../../services/typeintervention/typeintervention.service";
//import { ActivtieResponse } from "../../../data/http/responses/activite.response";
import { TypeInterventionResponse } from "../../../data/http/responses/typeintervention.response";
import { MatIcon } from "@angular/material/icon";
import { TypeActiviteResponse } from '../../../data/http/responses/typeactivite.response';
import { TypeActiviteService } from '../../../services/typeactivites/typeactivite.service';
import { OngletlayoutComponent } from '../../../components/layouts/ongletlayout/ongletlayout.component';
import { NgIf } from '@angular/common';
import { closeLocalStorage } from '../../../utils/helpers';
import { UiButtonComponent } from '../../../components/button/button.component';
@Component({
  templateUrl: "./activities.component.html",
  styleUrl: "./activities.component.css",
  selector: "app-activities-page",
  imports: [
    RouterOutlet,
    MatIcon,
    OngletlayoutComponent,
    //UiTable,
    NgIf,
    UiButtonComponent
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]

})



export class ActivityPage implements OnInit {

  constructor(
    private reportService: ReportService,
    private structureProgrammatiqueService: ActiviteForReportService,
    private typeInterventionService: TypeInterventionService,
    private typeActiviteService: TypeActiviteService,
    private router: Router,
    private route: ActivatedRoute,
    private AppService: AppService
  ) { }
  public data: any[] = []

  public typeactivities: TypeActiviteResponse[] = [];
  public structures: ActivtieResponse[] = [];
  public activites: ActivtieResponse[] = [];
  public typeInterventionData: TypeInterventionResponse[] = [];
  public taches: any[] | null = null;

  // BREAKPOINT ICI
  ngOnInit(): void {
    this.loadTypeIntervention();
    this.loadStructures();
    this.loadTypeActivite();
  }

  hasAccess(roles?: string[]): boolean {
    if (!roles || roles.length === 0) return true;
    // Utilise le même service que la sidebar
    if (this.AppService['authService'] && typeof this.AppService['authService'].hasAnyRole === 'function') {
      const result = this.AppService['authService'].hasAnyRole(roles);
      try {
        //console.debug('ExpressionBesoin.hasAccess check', { required: roles, userRoles: this.AppService['authService'].getUserRoles(), allowed: result });
      } catch (e) { }
      return result;
    }
    return false;
  }

  loadStructures(): void {
    this.structureProgrammatiqueService.getAllByAppId(this.AppService.getAppId()!).subscribe({
      next: (response: any) => {
        this.activites = response.data;
        //console.log("Activites : " + this.activites)
        this.structures = [];

        this.activites.forEach((activite) => {
          if (activite.typeActivite === "PROGRAMMES" || activite.typeActivite === "PROGRAMME") {
            this.structures.push(activite);
          }
        });

        // //console.log("Structure : " + this.structures)
      },
      error: (error) => {
        console.error('Erreur lors du chargement des structures :', error);
      }
    });
  }

  loadTypeIntervention(): void {
    this.typeInterventionService.getAllByAppId(this.AppService.getAppId()!).subscribe({
      next: (response: any) => {
        this.typeInterventionData = response.data;
      },
      error: (error) => {
        console.error('Erreur lors du chargement des structures :', error);
      }
    });
  }

  onClickMenu(): void {
    closeLocalStorage();
  }


  tableLinkForActivities = [
    {
      link: routeAlias.activities.structuresprogrammatiques.home,
      text: "Structure programmatiques"
    },
    {
      link: routeAlias.activities.activity.home,
      text: "Activités"
    },
  ]


  loadTypeActivite(): void {
    this.typeActiviteService.getAllByAppId(this.AppService.getAppId()!).subscribe({
      next: (response: any) => {
        this.typeactivities = response.data;
      },
      error: (error) => {
        console.error('Erreur lors du chargement des structures :', error);
      }
    });
  }


  findTaches(act: ActivtieResponse): any[] {
    let type: string = '';
    act.caracteristiques?.forEach((caract) => {
      if ("TYPE_ACTIVITE".toUpperCase() === caract.code) {
        type = caract.valeur;
        //console.log("code : " + caract.code + " valeur : " + caract.valeur);
      }
    });

    const foundTypeActivity = this.typeactivities.find(typeActivity => typeActivity.type_activite === type);
    if (foundTypeActivity) {
      return foundTypeActivity.taches;
    } else {
      return [];
    }
  }



  // Gestion des etat 
  /* --- Fonctions de génération de rapports --- */
  telechargerRapportPtaXlsx() {
    this.telechargerRapportPta("xlsx");
  }
  // Gestion des etat 
  /* --- Fonctions de génération de rapports --- */
  telechargerRapportPta(format = 'pdf') {
    this.structureProgrammatiqueService.getFullTree(this.AppService.getAppId()!).subscribe({
      next: (response: any) => {
        const fullTree: ActivtieResponse[] = response.data;
        const programmes = fullTree.filter((activite: ActivtieResponse) =>
          activite.typeActivite === "PROGRAMMES" || activite.typeActivite === "PROGRAMME"
        );
        this.genererRapportPta(programmes, format);
      },
      error: (error) => {
        console.error('Erreur lors du chargement de l\'arbre complet pour le rapport :', error);
      }
    });
  }

  private genererRapportPta(structures: ActivtieResponse[], format: string) {
    try {
      this.data = []
      let i: number = 0, j: number = 0, k: number = 0, l: number = 0, m: number = 0;

      structures.forEach((programme) => {
        i++;
        j = 0, k = 0, l = 0, m = 0;
        this.toData(`${i}`, programme)
        programme.taches?.forEach((ob) => {
          j++;
          k = 0, l = 0, m = 0;
          this.toData(`${i}.${j}`, ob)
          ob.taches?.forEach((resultat) => {
            k++;
            l = 0, m = 0;
            this.toData(`${i}.${j}.${k}`, resultat)
            resultat.taches?.forEach((act) => {
              l++;
              m = 0;
              this.toData(`${i}.${j}.${k}.${l}`, act);

              act.taches?.forEach((sousAct) => {
                m++;
                this.toData(`${i}.${j}.${k}.${l}.${m}`, sousAct);
              });

            })
          });
        });
      });

      const parameters = {
        annee: 2026,
        objectif_general: "Faire de la Clinique La Renaissance Divine une référence locale en soins de proximité de qualité à Aïdjèdo, fondée sur une gestion moderne, transparente, performante et orientée résultats. ",
      }
      if (this.data.length === 0) return;
      const reportObservable = this.reportService.generatePtaReport(format, this.data, parameters);

      reportObservable.subscribe({
        next: (blob: Blob) => {
          if (format === 'pdf') {
            this.reportService.openOrDownloadReport(blob, `pta.pdf`);
          } else {
            this.reportService.downloadReport(blob, `pta.${format}`);
          }
        },
        error: (err: any) => console.error('Erreur téléchargement :', err)
      });

    } catch (error) {
      console.error('Erreur lors du téléchargement du rapport:', error)
    }
  }


  toData(ref: string, act: ActivtieResponse) {

    //console.log(" activite : " + act)
    let imput_budget: number = 0;
    let montant_estim: number = 0;
    let produit: number = 0;
    let cout_prev: number = 0;
    let montant_dec: number = 0;
    let prev_dec: number = 0;
    let horizon: string = '';
    let coup_prev: number = 0;
    let poids: number = 0;
    let struc_res: string = '';
    let struc_asso: string = '';
    let superv: string = '';
    let mode_exec: string = '';
    let observation: string = '';
    let prev_dec_27: number = 0;
    let janvier: boolean = false;
    let fevrier: boolean = false;
    let mars: boolean = false;
    let avril: boolean = false;
    let mai: boolean = false;
    let juin: boolean = false;
    let juillet: boolean = false;
    let aout: boolean = false;
    let septembre: boolean = false;
    let octobre: boolean = false;
    let novembre: boolean = false;
    let decembre: boolean = false;

    act.caracteristiques?.forEach((caract) => {
      if ("SUPERVISOR".toUpperCase() === caract.code) {
        superv = caract.valeur;
        //console.log("code : " + caract.code + " valeur : " + caract.valeur);
      } else if ("MODEEXECUTION".toUpperCase() === caract.code || "MODE_EXECUTION".toUpperCase() === caract.code) {
        mode_exec = caract.valeur;
        //console.log("code : " + caract.code + " valeur : " + caract.valeur);
      } else if ("STRUCTASSOCIE".toUpperCase() === caract.code) {
        struc_asso = struc_asso === '' ? caract.valeur : struc_asso + ', ' + caract.valeur;
        //console.log("code : " + caract.code + " valeur : " + caract.valeur);
      } else if ("STRUCTURERESPONSABLE".toUpperCase() === caract.code || "STRUCTURE_RESPONSABLE".toUpperCase() === caract.code) {
        struc_res = caract.valeur;
        //console.log("code : " + caract.code + " valeur : " + caract.valeur);
      } else if ("MONTANT_ESTIMATIF".toUpperCase() === caract.code || "DECAISSEMENT_ESTIMATIF" === caract.code) {
        montant_estim = isNaN(Number(caract.valeur)) ? 0 : Number(caract.valeur);
        //console.log("code : " + caract.code + " valeur : " + caract.valeur);
      }  else if ("ENCAISSEMENT_ESTIMATIF" === caract.code) {
        produit = isNaN(Number(caract.valeur)) ? 0 : Number(caract.valeur);
        //console.log("code : " + caract.code + " valeur : " + caract.valeur);
      } else if ("IMPUTATIONBUDGETAIRE".toUpperCase() === caract.code || "IMPUTATION_BUDGETAIRE".toUpperCase() === caract.code) {
        imput_budget = isNaN(Number(caract.valeur)) ? 0 : Number(caract.valeur);
        //console.log("code : " + caract.code + " valeur : " + caract.valeur);
      } else if ("HORIZON".toUpperCase() === caract.code) {
        horizon = caract.valeur;
        //console.log("code : " + caract.code + " valeur : " + caract.valeur);
      } else if ("COUTPREVU2025".toUpperCase() === caract.code || "COUT_PREVU_N".toUpperCase() === caract.code) {
        cout_prev = isNaN(Number(caract.valeur)) ? 0 : Number(caract.valeur);
        //console.log("code : " + caract.code + " valeur : " + caract.valeur);
      } else if ("COUTPREVU2026".toUpperCase() === caract.code || "COUT_PREVU_N1".toUpperCase() === caract.code) {
        coup_prev = isNaN(Number(caract.valeur)) ? 0 : Number(caract.valeur);
        //console.log("code : " + caract.code + " valeur : " + caract.valeur);
      } else if ("PREVISIONDECAISSEMENTT4_2025" === caract.code || "PREVISION_DECAISSEMENT_T4_N" === caract.code) {
        prev_dec = isNaN(Number(caract.valeur)) ? 0 : Number(caract.valeur);
        //console.log("code : " + caract.code + " valeur : " + caract.valeur);
      } else if ("PREVISIONDECAISSEMENT2027" === caract.code || "PREVISION_DECAISSEMENT_N2" === caract.code) {
        prev_dec_27 = isNaN(Number(caract.valeur)) ? 0 : Number(caract.valeur);
        //console.log("code : " + caract.code + " valeur : " + caract.valeur);
      } else if ("MONTANTDECAISSEAU30SEPT2025".toUpperCase() === caract.code || "MONTANT_DECAISSE_AU30_SEPT_N" === caract.code) {
        montant_dec = isNaN(Number(caract.valeur)) ? 0 : Number(caract.valeur);
        //console.log("code : " + caract.code + " valeur : " + caract.valeur);

      } else if ("POIDS".toUpperCase() === caract.code) {
        poids = isNaN(Number(caract.valeur)) ? 0 : Number(caract.valeur);
        //console.log("code : " + caract.code + " valeur : " + caract.valeur);
      }else if ("JANVIER".toUpperCase() === caract.code) {
        janvier = Boolean(caract.valeur);
        //console.log("code : " + caract.code + " valeur : " + caract.valeur);
      } else if ("FEVRIER".toUpperCase() === caract.code) {
        fevrier = Boolean(caract.valeur);
        //console.log("code : " + caract.code + " valeur : " + caract.valeur);

      } else if ("MARS".toUpperCase() === caract.code) {
        mars = Boolean(caract.valeur);
        //console.log("code : " + caract.code + " valeur : " + caract.valeur);

      } else if ("AVRIL".toUpperCase() === caract.code) {
        avril = Boolean(caract.valeur);
        //console.log("code : " + caract.code + " valeur : " + caract.valeur);

      } else if ("MAI".toUpperCase() === caract.code) {
        mai = Boolean(caract.valeur);
        //console.log("code : " + caract.code + " valeur : " + caract.valeur);

      } else if ("JUIN".toUpperCase() === caract.code) {
        juin = Boolean(caract.valeur);
        //console.log("code : " + caract.code + " valeur : " + caract.valeur);

      } else if ("JUILLET".toUpperCase() === caract.code) {
        juillet = Boolean(caract.valeur);
        //console.log("code : " + caract.code + " valeur : " + caract.valeur);

      } else if ("AOUT".toUpperCase() === caract.code) {
        aout = Boolean(caract.valeur);
        //console.log("code : " + caract.code + " valeur : " + caract.valeur);

      } else if ("SEPTEMBRE".toUpperCase() === caract.code) {
        septembre = Boolean(caract.valeur);
        //console.log("code : " + caract.code + " valeur : " + caract.valeur);

      } else if ("OCTOBRE".toUpperCase() === caract.code) {
        octobre = Boolean(caract.valeur);
        //console.log("code : " + caract.code + " valeur : " + caract.valeur);

      } else if ("NOVEMBRE".toUpperCase() === caract.code) {
        novembre = Boolean(caract.valeur);
        //console.log("code : " + caract.code + " valeur : " + caract.valeur);

      } else if ("DECEMBRE".toUpperCase() === caract.code) {
        decembre = Boolean(caract.valeur);
        //console.log("code : " + caract.code + " valeur : " + caract.valeur);

      }
    });

    console.log("Date debut:" , act.dateDebut)

    console.log("Date fin", act.dateFin)

    //console.log(" type : " + act.typeActivite)
    const activite: IActivite = {
      type: act.typeActivite,
      num: ref,
      objectifs: act.titre,
      imput_budget: imput_budget,
      montant_estim: montant_estim,
      cout_prev: cout_prev,
      montant_dec: montant_dec,
      prev_dec: prev_dec,
      horizon: horizon,
      coup_prev: coup_prev,
      poids: poids,
      struc_res: struc_res,
      struc_asso: struc_asso,
      superv: superv,
      mode_exec: mode_exec,
      observation: observation,
      prev_dec_27: prev_dec_27,
      produit: produit,
      date_debut: act.dateDebut ? new Date(act.dateDebut) : null,
      date_fin: act.dateFin ? new Date(act.dateFin) : null,

    };
    this.data.push({ ...activite });
  }

  toTacheData(ref: string, act: any) {

    //console.log(" tache : " + act)
    //console.log(" type : " + act.typeActivite)
    //console.log(" tache : " + act.tache)
    const activite: IActivite = createActivite({
      type: "TACHE",
      num: ref,
      objectifs: act.tache,
      poids: act.poids,
    });

    this.data.push({ ...activite });
  }


}